// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface AgentRunLog
 */
export interface AgentRunLog {
  /**
   *
   * @type {number}
   * @memberof AgentRunLog
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof AgentRunLog
   */
  agentRun: number;
  /**
   * Monotonic per run. Used for ordering and for resuming a tail
   * @type {number}
   * @memberof AgentRunLog
   */
  seq: number;
  /**
   *
   * @type {string}
   * @memberof AgentRunLog
   */
  level?: AgentRunLogLevelEnum;
  /**
   * Redacted on the way in, never on the way out
   * @type {string}
   * @memberof AgentRunLog
   */
  message: string;
  /**
   *
   * @type {string}
   * @memberof AgentRunLog
   */
  createdAt?: string;
}

export function AgentRunLogFromJSON(json: any): AgentRunLog {
  return {
    id: json["id"],
    agentRun: json["agent_run"],
    seq: json["seq"],
    level: !exists(json, "level") ? undefined : json["level"],
    message: json["message"],
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
  };
}

export function AgentRunLogToJSON(value?: AgentRunLog): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    id: value.id,
    agent_run: value.agentRun,
    seq: value.seq,
    level: value.level,
    message: value.message,
    created_at: value.createdAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum AgentRunLogLevelEnum {
  Info = "info",
  Warn = "warn",
  Error = "error",
  Tool = "tool",
  Output = "output",
}
